import styled from "styled-components";
import { theme } from "styles/theme";

export const HistoryTableWrapper = styled.div`
  margin-top: 1rem;
  color: ${theme.colors.textPrimary};

  .p-datatable {
    border: none !important;
    box-shadow: none !important;
    border-radius: 0 !important;
    overflow: visible;
    background: transparent !important;
    color: ${theme.colors.textPrimary};
  }

  .p-datatable-wrapper {
    border-radius: 0 !important;
  }

  .p-datatable-thead > tr > th {
    background: transparent !important;
    color: ${theme.colors.textSecondary} !important;
    font-weight: 600;
    font-size: 0.8rem !important;
    line-height: 1.4 !important;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    border: none !important;
    border-bottom: 1px solid ${theme.colors.border} !important;
    padding: 0.875rem 0.5rem 0.875rem 0 !important;
    vertical-align: middle;
    overflow: visible !important;
  }

  .p-sortable-column:not(.p-highlight):hover,
  .p-sortable-column.p-highlight {
    background: ${theme.colors.bgLight} !important;
    color: ${theme.colors.textPrimary} !important;
  }

  .p-sortable-column-icon {
    color: inherit !important;
  }

  .p-datatable-tbody > tr {
    background: transparent !important;
    color: ${theme.colors.textPrimary};
  }

  .p-datatable-tbody > tr > td {
    border-color: ${theme.colors.border} !important;
    padding: 0.875rem 0;
    font-size: 0.875rem;
    vertical-align: middle;
    color: ${theme.colors.textPrimary};
  }

  .p-datatable-tbody > tr.p-row-odd {
    background: ${theme.colors.bgLight} !important;
  }

  .p-datatable-tbody > tr:hover > td {
    background: ${theme.colors.tertiaryTransparent} !important;
    box-shadow: none;
  }

  .p-paginator {
    border: none !important;
    border-top: 1px solid ${theme.colors.border} !important;
    background: transparent !important;
    border-radius: 0 !important;
    padding: 0.5rem 0 !important;
  }

  .p-datatable-emptymessage td {
    text-align: center;
    color: ${theme.colors.textSecondary};
    padding: 3rem 0;
    font-size: 0.9rem;
    border: none !important;
  }
`;

export const EventTypeChip = styled.span<{ eventType: string }>`
  padding: 0.25rem 0.625rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  white-space: nowrap;
  background-color: ${(props) => {
    switch (props.eventType) {
      case "ATTACH_DEVICE_TO_USER":
        return theme.colors.successBg;
      case "DETACH_DEVICE_FROM_USER":
        return theme.colors.errorBg;
      case "SCHEDULE_UPDATE":
        return theme.colors.infoLight;
      case "CONFIG_UPDATED":
        return theme.colors.warningBg;
      case "FIRMWARE_UPDATE":
        return theme.colors.tertiaryTransparent;
      default:
        return theme.colors.lightGrey;
    }
  }};
  color: ${(props) => {
    switch (props.eventType) {
      case "ATTACH_DEVICE_TO_USER":
        return theme.colors.statusActiveText;
      case "DETACH_DEVICE_FROM_USER":
        return theme.colors.statusInactiveText;
      case "SCHEDULE_UPDATE":
        return theme.colors.infoDark;
      case "CONFIG_UPDATED":
        return theme.colors.warningText;
      case "FIRMWARE_UPDATE":
        return theme.colors.tertiaryDark;
      default:
        return theme.colors.textSecondary;
    }
  }};
`;

export const SourceChip = styled.span<{ source: string }>`
  padding: 0.25rem 0.625rem;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  background-color: ${(props) => {
    switch (props.source) {
      case "APP":
        return theme.colors.warningBg;
      case "PORTAL":
        return theme.colors.tertiaryTransparent;
      default:
        return theme.colors.lightGrey;
    }
  }};
  color: ${(props) => {
    switch (props.source) {
      case "APP":
        return theme.colors.warningText;
      case "PORTAL":
        return theme.colors.tertiaryDark;
      default:
        return theme.colors.textSecondary;
    }
  }};
`;
